<template>
  <div class="content">
      <div class="block block-rounded block-fx-shadow">
        <div class="block-header">
          <h3 class="block-title">{{ $t('permissions.index') }}</h3>
          <div class="block-options">
            <b-btn v-b-modal.addpermission size="sm" variant="primary">{{ $t('permissions.add') }}</b-btn>
          </div>
        </div>
        <div class="table-responsive-xl">
          <table class="table table-bordered  table-hover display">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('app.id') }}</th>
                <th>{{ $t('app.display_name') }}</th>
                <th>{{ $t('app.name') }}</th>
                <th>{{ $t('app.desc') }}</th>
                <th>{{ $t('app.action') }}</th>
              </tr>
            </thead>
            <tbody>
                <template v-if="!loadRoles">
                  <tr v-for="(permission, index) in permissions" :key="permission.id">
                      <td>{{index+1}}</td>
                      <td>{{permission.id}}</td>
                      <td>{{permission.display_name}}</td>
                      <td>{{permission.name}}</td>
                      <td>{{permission.description}}</td>
                      <td>
                          <div class="btn-group" role="group" aria-label="btnGroup1">
                            <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm" title="Редактировать">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button @click.prevent="handleDelete(permission.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" title="Удалить">
                              <i class="fa fa-times-circle"></i>
                            </button>
                          </div>
                      </td>
                  </tr>
                </template>
                <tr v-if="loadRoles">
                    <td colspan="6">
                        <loader-wave/>
                    </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div><!-- end card-->

      <b-modal size="lg" :title="$t('permissions.edit')" ref="modalUpdatePermissions" @ok="handleUpdate" @shown="fetchPermissions" :ok-title="$t('buttons.save')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
          <div class="form-group">
              <label for="UpdateName" class="col-form-label">{{ $t('app.name') }}</label>
              <pre class="form-control"><strong>{{update_permission.name}}</strong></pre>
          </div>
          <div class="form-group">
              <label for="updatedisplayname" class="col-form-label">{{ $t('app.display_name') }}</label>
              <input type="text" class="form-control" v-model="update_permission.display_name" :class="{'is-invalid': update_errors.display_name }" id="updatedisplayname">
              <span v-if="update_errors.display_name" class="invalid-feedback">
                  <strong>{{update_errors.display_name ? update_errors.display_name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="update_permission.description" :class="{'is-invalid': update_errors.description }" id="updatedescription">
              <span v-if="update_errors.description" class="invalid-feedback">
                  <strong>{{update_errors.description ? update_errors.description[0] : '' }}</strong>
              </span>
          </div>
      </b-modal>

      <b-modal id="addpermission" size="lg" :title="$t('permissions.add')" ref="modalAddPermission" @ok="handleStore" @shown="fetchPermissions" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
          <div class="form-group">
              <label for="storeName" class="col-form-label">{{ $t('app.name') }}</label>
              <input type="text" class="form-control" v-model="permission.name" :class="{'is-invalid': errors.name }" id="storeName">
              <span v-if="errors.name" class="invalid-feedback">
                  <strong>{{errors.name ? errors.name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="storeDisplayName" class="col-form-label">{{ $t('app.display_name') }}</label>
              <input type="text" class="form-control" v-model="permission.display_name" :class="{'is-invalid': errors.display_name }" id="storeDisplayName">
              <span v-if="errors.display_name" class="invalid-feedback">
                  <strong>{{errors.display_name ? errors.display_name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="storeDescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="permission.description" :class="{'is-invalid': errors.description }" id="storeDescription">
              <span v-if="errors.description" class="invalid-feedback">
                  <strong>{{errors.description ? errors.description[0] : '' }}</strong>
              </span>
          </div>
      </b-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: [],
      permissions: [],
      permission: {
        name: '',
        display_name: '',
        description: '',
      },
      errors: {},
      update_errors: {},
      update_permission: {},
      isProcessing: false,
      loadRoles: false,
    };
  },
  mounted() {
    this.fetchPermissions();
  },
  methods: {
    fetchPermissions() {
      this.loadRoles = true;
      window.axios.get('/admin/permissions')
        .then((res) => {
          this.permissions = res.data.permissions;
        })
        .finally(() => {
          this.loadRoles = false;
        });
    },

    clearModal() {
      this.permission.name = '';
      this.permission.display_name = '';
      this.permission.description = '';
    },

    clearUpdateModal() {
      this.update_permission = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.update_permission = this.permissions[index];
      this.$refs.modalUpdatePermissions.show();
    },

    handleStore(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.storePermission();
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.updatePermission();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deletePermissions(id);
        }
      })
    },

    storePermission() {
      window.axios.post('/admin/permissions', this.permission)
        .then((res) => {
          if (res.status === 201) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.$refs.modalAddPermission.hide();
            this.clearModal();
            this.fetchPermissions();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updatePermission() {
      window.axios.put(`/admin/permissions/${this.update_permission.id}`, this.update_permission)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdatePermissions.hide();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.fetchPermissions();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deletePermissions(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/permissions/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchPermissions();
          }
          this.isProcessing = false;
        });
    },
  },
};
</script>
